type TwitterHandleMapping = {
    [brand: string]: string;
};

export const TWITTER_HANDLE_MAPPING: TwitterHandleMapping = {
    businessweek: "BW",
    citylab: "citylab",
    crypto: "crypto",
    economics: "economics",
    equality: "bbgequality",
    gadfly: "opinion",
    green: "climate",
    markets: "markets",
    opinion: "opinion",
    politics: "bpolitics",
    pursuits: "luxury",
    technology: "technology",
    view: "opinion",
    wealth: "wealth",
    "work-shift": "thefuture",
};

const DEFAULT_HANDLE = "business";

export const getTwitterHandle = (brand: string) =>
    `@${TWITTER_HANDLE_MAPPING[brand] || DEFAULT_HANDLE}`;
